import React, { useEffect, useState, useRef, useCallback } from "react";
import {
    Modal,
    ScrollView,
    Text,
    TouchableOpacity,
    TouchableWithoutFeedback,
    View,
    Image,
    StyleSheet,
    ActivityIndicator,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { ProgressBar } from "react-native-paper";
import { AppColors } from "../../../../../utility/AppColors";
import { AppImages } from "../../../../../utility/AppImages";
import ImageComponent from "../../../../../Components/ImageComponent";
import { format, isValid } from "date-fns";
import { toast } from "react-toastify";
import Avatar from "../../../../../Components/choose-avatar-components/Avatar";
import { useNavigation, StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../../../utility/NavigationHelper";
import { AppScreens } from "../../../../Utility/AppScreens";
import { base_url, endpoints } from "../../../../../Api/configs";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../../../services/activityService";
import { getNotificationById } from "../../../../../services/notification";
import { useNotifications } from "../../../../../context/NotificationContext";
import { useUserData } from "../../../../../context/UserDataContext";
import { fetchUserBalance, fetchPaymentBeltExchange } from "../../../../../services/profileAPI";
import { handleApiError } from "../../../../../services/errorHandler";
import { fetchUserConnectionStatus } from "../../../../../services/stream";
import ChallengeAcceptModal from "./ChallengeAcceptModal";
import CornfirmPurchaseBeltModal from "../../BeltScreens/CornfirmPurchaseBeltModal";
import BeltPurchaseSuccessModal from "../../BeltScreens/BeltPurchaseSuccessModal";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

interface MobileNotificationDetailsProps {
    showModal: boolean;
    setShowModal: (show: boolean) => void;
    onAcceptPress?: (accepted: boolean) => void;
    challengeID: string;
    accessToken: string;
    username: string;
}

export function MobileNotificationDetails(props: MobileNotificationDetailsProps) {
    const {
        showModal = false,
        setShowModal,
        onAcceptPress,
        challengeID,
        accessToken,
        username,
    } = props;

    const navigation = useNavigation();
    const deviceSize = useDeviceSize();
    const { userData } = useUserData();
    const { sendNotification, setUpdateNotification, showChallengeActionPopup } = useNotifications();
    const scrollViewRef = useRef<ScrollView>(null);

    const [showCreateLoader, setCreateShowLoader] = useState(false);
    const [showAcceptLoader, setAcceptLoader] = useState(false);
    const [loadingAction, setLoadingAction] = useState<'accept' | 'reject' | null>(null);
    const [challengeDetails, setChallengeDetails] = useState<any>(null);
    const [profileData, setProfileData] = useState<any>(null);
    const [showDetails, setShowDetails] = useState(false);
    const [isNegotiating, setIsNegotiating] = useState(false);
    const [showAcceptModal, setShowAcceptModal] = useState(false);
    const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] = useState(false);
    const [numberOfBelts, setNumberOfBelts] = useState("0");
    const [insufficientStakesError, setInsufficientStakesError] = useState<any>(null);
    const [userBalanceData, setUserBalanceData] = useState<any>(null);
    const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] = useState(false);
    const [refreshAPICall, setRefreshAPICall] = useState(false);
    const [platformStatus, setPlatformStatus] = useState({
        YouTube: "Not connected",
        Twitch: "Not connected",
    });
    const [arrBeltMedalType, setArrBeltMedalType] = useState([
        { id: 0, value: 0, image: AppImages.icCoinBelt, title: "Coin", isSelected: false, currentPrize: 0, sellPrice: 0 },
        { id: 1, image: AppImages.icBronzeBelt, title: "Bronze", isSelected: true, currentPrize: 0, value: 0, sellPrice: 0 },
        { id: 2, image: AppImages.icSilverBelt, title: "Silver", isSelected: false, currentPrize: 0, value: 0, sellPrice: 0 },
        { id: 3, image: AppImages.icGoldBelt, title: "Gold", isSelected: false, currentPrize: 0, value: 0, sellPrice: 0 },
        { id: 4, image: AppImages.icPlatinumBelt, title: "Platinum", isSelected: false, currentPrize: 0, value: 0, sellPrice: 0 },
    ]);

    // Fetch challenge details on mount
    useEffect(() => {
        if (challengeID && accessToken && showModal) {
            callGetChallengeDetails(challengeID);
            checkUserBalanceAPI();
            paymentBeltExchangeAPI();
            fetchUserProfileData();
        }
    }, [challengeID, accessToken, showModal]);

    const callGetChallengeDetails = async (notificationId: string) => {
        setCreateShowLoader(true);
        try {
            const response = await getNotificationById(accessToken, notificationId);
            if (response.statusCode === 200) {
                setChallengeDetails(response.body.notification);
            } else {
                toast.error("Failed to fetch challenge details");
                setShowModal(false);
            }
        } catch (error) {
            toast.error("Failed to fetch challenge details");
            setShowModal(false);
        } finally {
            setCreateShowLoader(false);
        }
    };

    const fetchStatus = async () => {
        try {
            const response = await fetchUserConnectionStatus(accessToken);
            if (response.statusCode === 200) {
                setPlatformStatus(response.body);
            }
        } catch (error) {
            console.error("Error fetching platform status:", error);
        }
    };

    const fetchUserProfileData = useCallback(async () => {
        try {
            const response = await fetch(`${base_url}${endpoints.auth.userProfile}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ accessToken }),
            });
            const data = await response.json();
            if (response.status === 200) {
                setProfileData(data.body);
            }
        } catch (error) {
            console.error("Failed to fetch user profile data:", error);
        }
    }, [accessToken]);

    const checkUserBalanceAPI = async () => {
        try {
            const data = await fetchUserBalance(accessToken);
            const responseBody = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data) {
                setUserBalanceData(responseBody);
                const belts = responseBody?.belts;
                if (belts) {
                    const arr = [...arrBeltMedalType];
                    arr.forEach((item) => {
                        if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
                        else if (item.title === "Silver") item.value = Number(belts.silver || 0);
                        else if (item.title === "Gold") item.value = Number(belts.gold || 0);
                        else if (item.title === "Platinum") item.value = Number(belts.platinum || 0);
                    });
                    setArrBeltMedalType(arr);
                }
            }
        } catch (error: any) {
            console.error("Error checking user balance:", error);
        }
    };

    const paymentBeltExchangeAPI = async () => {
        try {
            const response = await fetchPaymentBeltExchange(accessToken);
            if (response.statusCode === 200) {
                const arr = [...arrBeltMedalType];
                arr.forEach((item) => {
                    if (item.title === "Bronze") {
                        item.currentPrize = Number(response.exchangeRates?.bronze || 550);
                        item.sellPrice = Number(response.sellRates?.bronze || 0);
                    } else if (item.title === "Silver") {
                        item.currentPrize = Number(response.exchangeRates?.silver || 5500);
                        item.sellPrice = Number(response.sellRates?.silver || 0);
                    } else if (item.title === "Gold") {
                        item.currentPrize = Number(response.exchangeRates?.gold || 55000);
                        item.sellPrice = Number(response.sellRates?.gold || 0);
                    } else if (item.title === "Platinum") {
                        item.currentPrize = Number(response.exchangeRates?.platinum || 550000);
                        item.sellPrice = Number(response.sellRates?.platinum || 0);
                    }
                });
                setArrBeltMedalType(arr);
            }
        } catch (error: any) {
            console.error("Error fetching belt exchange rates:", error);
        }
    };

    const handleAcceptPress = async (userResponse: boolean) => {
        setAcceptLoader(true);
        const url = `${base_url}${endpoints.events.challengeRespond}`;

        try {
            const response = await fetch(url, {
                mode: "cors",
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    accessToken,
                    notificationId: challengeID,
                    response: userResponse,
                }),
            });

            const data = await response.json();

            if (response.status === 200) {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    toast.success(userResponse ? "Challenge Accepted Successfully" : "Challenge Rejected Successfully");

                    const { body } = data;
                    // Parse the body if it's a string (API returns JSON string)
                    const parsedBody = typeof body === "string" ? JSON.parse(body) : body;
                    const { notificationId, senderId } = parsedBody;

                    if (userResponse && onAcceptPress) {
                        onAcceptPress(userResponse);
                    }

                    // Track activity
                    const activityType = userResponse ? ACTIVITY_TYPES.CHALLENGE_ACCEPTED : ACTIVITY_TYPES.CHALLENGE_REJECTED;
                    const eventId = challengeDetails?.eventDetails?.eventID;
                    if (eventId) {
                        storeUserActivity(accessToken, eventId, activityType).catch((err) =>
                            console.warn(`Error tracking ${activityType}:`, err)
                        );
                    }

                    setUpdateNotification({ challengeId: challengeID, response: userResponse });
                    await sendNotification(senderId, notificationId);

                    if (userResponse) {
                        await fetchStatus();
                        setShowAcceptModal(true);
                    } else {
                        setShowModal(false);
                        setTimeout(() => {
                            // @ts-ignore
                            showChallengeActionPopup("reject", false);
                        }, 500);
                    }
                } else if (data.statusCode === 400) {
                    // Insufficient stakes
                    let errorMessage = "";
                    if (data.body && typeof data.body === "object" && data.body.error) {
                        errorMessage = data.body.error;
                    } else if (typeof data.body === "string") {
                        try {
                            const parsedBody = JSON.parse(data.body);
                            errorMessage = parsedBody.error || "";
                        } catch (e) {
                            errorMessage = data.body;
                        }
                    }

                    const match = errorMessage.match(/Required:\s*(\d+)\s*(\w+)/i);
                    if (match) {
                        const requiredAmount = parseInt(match[1]);
                        const beltType = match[2];
                        setInsufficientStakesError({ requiredAmount, beltType, fullMessage: errorMessage });
                        const userBronzeBelts = arrBeltMedalType.find((b) => b.title === "Bronze")?.value || 0;
                        const beltsToBuy = Math.max(0, requiredAmount - userBronzeBelts);
                        setNumberOfBelts(beltsToBuy.toString());
                    } else {
                        setInsufficientStakesError({ fullMessage: errorMessage });
                    }
                    setCornfirmPurchaseBeltModal(true);
                } else {
                    toast.error("Failed to respond to challenge");
                }
            } else {
                toast.error("Failed to respond to challenge");
            }
        } catch (error) {
            toast.error("Failed to respond to challenge");
        } finally {
            setAcceptLoader(false);
        }
    };

    const handleNegotiateTerms = async () => {
        setIsNegotiating(true);
        try {
            const response = await fetch(`${base_url}${endpoints.events.negotiateTerms}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    accessToken,
                    eventId: challengeDetails?.eventDetails?.eventID,
                    newOpponentId: username || userData?.userID,
                }),
            });

            const data = await response.json();

            if (response.ok && (data.message || data.chatId)) {
                toast.success("Terms negotiated successfully");
                storeUserActivity(accessToken, challengeDetails?.eventDetails?.eventID, ACTIVITY_TYPES.NEGOTIATION_STARTED)
                    .catch((err) => console.warn("Failed to track activity:", err));

                setShowModal(false);
                navigation.dispatch(
                    StackActions.replace(AppScreens.OnGoingEvents, {
                        eventID: challengeDetails?.eventDetails?.eventID,
                        tab: "Chat",
                    })
                );
            } else {
                toast.error(data.error || "Failed to negotiate terms");
            }
        } catch (error) {
            toast.error("Failed to negotiate terms. Please try again.");
        } finally {
            setIsNegotiating(false);
        }
    };

    const handleProfileUpdate = async () => {
        if (!profileData) return;

        const updatedChallenged = [
            ...(profileData?.challenged || []),
            {
                eventId: challengeDetails?.eventDetails?.eventID,
                gameTitle: challengeDetails?.eventDetails?.gameTitle,
            },
        ];

        try {
            await fetch(`${base_url}${endpoints.auth.updateProfile}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ body: { username, accessToken, challenged: updatedChallenged } }),
            });
        } catch (error) {
            console.error("Failed to update user profile:", error);
        }
    };

    const formatDate = (date: string) => {
        const eventDate = new Date(date);
        if (!isValid(eventDate)) return "Invalid date";
        return format(eventDate, "MM/dd/yyyy HH:mm");
    };

    const calculateProgress = (won: number, total: number) => {
        if (total === 0) return 0;
        return won / total;
    };

    const beltData = (challengeDetails?.eventDetails?.stakes ?? [])
        .filter((stake: any) => stake.quantity > 0)
        .map((stake: any) => {
            let beltImage;
            switch (stake.type) {
                case "Token": beltImage = AppImages.icCoinBelt; break;
                case "Bronze": beltImage = AppImages.icBronzeBelt; break;
                case "Silver": beltImage = AppImages.icSilverBelt; break;
                case "Gold": beltImage = AppImages.icGoldBelt; break;
                case "Platinum": beltImage = AppImages.icPlatinumBelt; break;
                default: beltImage = AppImages.icCoinBelt;
            }
            return { beltImage, amount: stake.quantity };
        });

    const eventDetails = challengeDetails?.eventDetails;

    if (showAcceptModal) {
        return (
            <ChallengeAcceptModal
                eventID={eventDetails?.eventID}
                showModal={showAcceptModal}
                eventDetails={eventDetails}
                setShowModal={setShowAcceptModal}
                setPopup={() => {
                    setShowAcceptModal(false);
                    setShowModal(false);
                }}
                platformStatus={platformStatus}
            />
        );
    }

    return (
        <Modal animationType="slide" transparent={true} visible={showModal} onRequestClose={() => setShowModal(false)}>
            <TouchableWithoutFeedback onPress={() => setShowModal(false)}>
                <View style={styles.overlay}>
                    <TouchableWithoutFeedback onPress={(e) => e.stopPropagation()}>
                        <LinearGradient
                            colors={["#111827", "#000000"]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 1 }}
                            style={[styles.container, {
                                shadowColor: "rgba(232, 232, 232, 0.15)",
                                shadowOffset: { width: 0, height: -3 },
                                shadowOpacity: 1,
                                shadowRadius: 14,
                            }]}
                        >
                            <View style={styles.handleBar} />

                            {/* Header */}
                            <View style={styles.header}>
                                <Image source={AppImages.icNotificationLogo} style={{ height: 45, width: 70 }} resizeMode="contain" />
                                <Image source={AppImages.icNotificationBarcode} style={{ height: 25, width: 200 }} resizeMode="contain" />
                            </View>

                            {showCreateLoader ? (
                                <View style={styles.loadingContainer}>
                                    <ActivityIndicator size="large" color="#DC2626" />
                                    <Text style={styles.loadingText}>Loading challenge details...</Text>
                                </View>
                            ) : (
                                <ScrollView
                                    ref={scrollViewRef}
                                    style={styles.scrollView}
                                    showsVerticalScrollIndicator={false}
                                    contentContainerStyle={styles.scrollContent}
                                >
                                    {/* Section 1: Player Card */}
                                    <LinearGradient
                                        colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                                        start={{ x: 0, y: 0 }}
                                        end={{ x: 1, y: 1 }}
                                        style={styles.playerCard}
                                    >
                                        {/* Player Avatar */}
                                        <View style={styles.avatarContainer}>
                                            <Text style={styles.kallerLabel}>Kaller</Text>
                                            <View style={styles.avatarWrapper}>
                                                <Avatar src={eventDetails?.organiserProfilePicture} variant="notificationLargePlayer" />
                                            </View>
                                            <View style={styles.statsContainer}>
                                                <View style={styles.statRow}>
                                                    <Text style={styles.statLabel}>Games Won</Text>
                                                    <Text style={styles.statValue}>
                                                        {eventDetails?.participantProfiles?.[0]?.gamesWonCount || 0}
                                                    </Text>
                                                </View>
                                                <ProgressBar
                                                    progress={calculateProgress(
                                                        eventDetails?.participantProfiles?.[0]?.gamesWonCount || 0,
                                                        eventDetails?.participantProfiles?.[0]?.playedGamesCount || 1
                                                    )}
                                                    color={AppColors.green_44aeb4}
                                                    style={styles.progressBar}
                                                />
                                                <View style={[styles.statRow, { marginTop: 2 }]}>
                                                    <Text style={styles.statLabel}>Played Games</Text>
                                                    <Text style={styles.statValue}>
                                                        {eventDetails?.participantProfiles?.[0]?.playedGamesCount || 0}
                                                    </Text>
                                                </View>
                                                <ProgressBar progress={1} color={AppColors.green_44aeb4} style={styles.progressBar} />
                                            </View>
                                        </View>

                                        {/* Challenge Text */}
                                        <View style={styles.challengeTextContainer}>
                                            <Text style={styles.challengeText}>
                                                <Text style={{ fontWeight: "800" }}>{eventDetails?.organiserId}</Text>
                                                {" has challenged you in\n"}
                                                <Text style={{ fontWeight: "800", color: "#DC2626" }}>
                                                    {eventDetails?.gameTitle?.toUpperCase()}
                                                </Text>
                                            </Text>
                                            <Text style={styles.willStartText}>Will start on:</Text>
                                            <View style={styles.timeBox}>
                                                <Text style={styles.timeText}>{formatDate(eventDetails?.eventStartTime)}</Text>
                                            </View>
                                        </View>

                                        {/* Game Image */}
                                        <ImageComponent url={eventDetails?.gameImage} style={styles.gameImage} />
                                    </LinearGradient>

                                    {/* Section 2: Challenge Rewards */}
                                    <LinearGradient
                                        colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                                        start={{ x: 0, y: 0 }}
                                        end={{ x: 1, y: 1 }}
                                        style={styles.beltsCard}
                                    >
                                        <Text style={styles.beltsTitle}>Challenge Rewards</Text>
                                        <Text style={styles.beltsDescription}>
                                            Both players put Belts into the pot. Winner takes it all. To accept this challenge, you'll need to
                                            match {eventDetails?.organiserId}'s Belts
                                        </Text>

                                        <View style={styles.beltsRow}>
                                            {beltData.map((belt: any, index: number) => (
                                                <View key={index} style={styles.beltItem}>
                                                    <Image source={belt.beltImage} style={styles.beltImage} resizeMode="contain" />
                                                    <View style={styles.beltAmountBox}>
                                                        <Text style={styles.beltAmount}>{belt.amount}</Text>
                                                    </View>
                                                </View>
                                            ))}
                                        </View>

                                        <View style={styles.creditsRow}>
                                            <View>
                                                <Text style={styles.creditsLabel}>
                                                    Accept challenge to earn:{" "}
                                                    <Text style={{ fontWeight: "700" }}>{eventDetails?.totalCredits || 350}</Text>
                                                </Text>
                                                <Text style={styles.creditsWorthLabel}>Credits worth</Text>
                                            </View>
                                            <View style={styles.priceBox}>
                                                <Text style={styles.priceText}>${eventDetails?.creditsWorth || 13}</Text>
                                            </View>
                                        </View>
                                    </LinearGradient>

                                    {/* Section 3: Action Buttons */}
                                    <View style={styles.actionButtonsRow}>
                                        <TouchableOpacity
                                            style={styles.negotiateButton}
                                            onPress={handleNegotiateTerms}
                                            disabled={isNegotiating}
                                        >
                                            <ImageComponent url={AppImages.icNotificationMessage} style={{ width: 16, height: 16 }} />
                                            <Text style={styles.negotiateButtonText}>Negotiate Terms</Text>
                                        </TouchableOpacity>

                                        <TouchableOpacity
                                            style={styles.viewDetailsButton}
                                            onPress={() => {
                                                setShowDetails(!showDetails);
                                                if (!showDetails) {
                                                    setTimeout(() => {
                                                        scrollViewRef.current?.scrollToEnd({ animated: true });
                                                    }, 100);
                                                }
                                            }}
                                        >
                                            <Text style={styles.viewDetailsText}>
                                                {showDetails ? "Hide details" : "View challenge details"}
                                            </Text>
                                        </TouchableOpacity>
                                    </View>

                                    {/* Section 4: Description */}
                                    {showDetails && eventDetails?.description && (
                                        <LinearGradient
                                            colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                                            start={{ x: 0, y: 0 }}
                                            end={{ x: 1, y: 1 }}
                                            style={styles.rulesCard}
                                        >
                                            <Text style={styles.rulesTitle}>Rules & Description:</Text>
                                            <Text style={styles.rulesText}>{eventDetails?.description}</Text>
                                        </LinearGradient>
                                    )}

                                    {/* Section 5: Event Details Row */}
                                    {showDetails && (
                                        <LinearGradient
                                            colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                                            start={{ x: 0, y: 0 }}
                                            end={{ x: 1, y: 1 }}
                                            style={styles.eventDetailsCard}
                                        >
                                            <View style={styles.eventDetailsRow}>
                                                <View style={styles.eventDetailItem}>
                                                    <Text style={styles.eventDetailLabel}>Event name:</Text>
                                                    <LinearGradient colors={["#1F2937", "#111827"]} style={styles.eventDetailValueBox}>
                                                        <Text style={styles.eventDetailValue}>{eventDetails?.eventTitle || "N/A"}</Text>
                                                    </LinearGradient>
                                                </View>
                                                <View style={styles.eventDetailItem}>
                                                    <Text style={styles.eventDetailLabel}>Event Type</Text>
                                                    <LinearGradient colors={["#1F2937", "#111827"]} style={styles.eventDetailValueBox}>
                                                        <Text style={styles.eventDetailValue}>{eventDetails?.eventType || "Kall-Out"}</Text>
                                                    </LinearGradient>
                                                </View>
                                                <View style={styles.eventDetailItem}>
                                                    <Text style={styles.eventDetailLabel}>Game</Text>
                                                    <LinearGradient colors={["#1F2937", "#111827"]} style={styles.eventDetailValueBox}>
                                                        <Text style={styles.eventDetailValue}>{eventDetails?.gameTitle || "N/A"}</Text>
                                                    </LinearGradient>
                                                </View>
                                                <View style={styles.eventDetailItem}>
                                                    <Text style={styles.eventDetailLabel}>Device</Text>
                                                    <LinearGradient colors={["#1F2937", "#111827"]} style={styles.eventDetailValueBox}>
                                                        <Text style={styles.eventDetailValue}>{eventDetails?.device || "PC"}</Text>
                                                    </LinearGradient>
                                                </View>
                                                <View style={styles.eventDetailItem}>
                                                    <Text style={styles.eventDetailLabel}>Gamer Id</Text>
                                                    <LinearGradient colors={["#1F2937", "#111827"]} style={styles.eventDetailValueBox}>
                                                        <Text style={styles.eventDetailValue}>
                                                            {eventDetails?.gamerID?.organiser || eventDetails?.organiserId || "N/A"}
                                                        </Text>
                                                    </LinearGradient>
                                                </View>
                                            </View>
                                        </LinearGradient>
                                    )}
                                </ScrollView>
                            )}

                            {/* Fixed Footer */}
                            <View style={styles.footer}>
                                <TouchableOpacity
                                    style={styles.rejectButton}
                                    onPress={() => {
                                        setLoadingAction('reject');
                                        handleAcceptPress(false);
                                    }}
                                    disabled={showAcceptLoader}
                                >
                                    {loadingAction === 'reject' && showAcceptLoader ? (
                                        <ActivityIndicator size="small" color="#DC2626" />
                                    ) : (
                                        <Text style={styles.rejectButtonText}>Reject</Text>
                                    )}
                                </TouchableOpacity>

                                <TouchableOpacity
                                    style={styles.acceptButton}
                                    onPress={() => {
                                        setLoadingAction('accept');
                                        handleAcceptPress(true);
                                    }}
                                    disabled={showAcceptLoader}
                                >
                                    {loadingAction === 'accept' && showAcceptLoader ? (
                                        <ActivityIndicator size="small" color="#FFF" />
                                    ) : (
                                        <Text style={styles.acceptButtonText}>Accept</Text>
                                    )}
                                </TouchableOpacity>
                            </View>
                        </LinearGradient>
                    </TouchableWithoutFeedback>
                </View>
            </TouchableWithoutFeedback>

            {/* Belt Purchase Modal */}
            {cornfirmPurchaseBeltModal && (
                <CornfirmPurchaseBeltModal
                    accessToken={accessToken}
                    numberOfBelts={numberOfBelts}
                    setArrBeltMedalType={setArrBeltMedalType}
                    arrBeltMedalType={arrBeltMedalType}
                    showModal={cornfirmPurchaseBeltModal}
                    setRefreshAPICall={setRefreshAPICall}
                    userBalanceData={userBalanceData}
                    setShowModal={setCornfirmPurchaseBeltModal}
                    eventID={eventDetails?.eventID || challengeID}
                    dataSelectedBelt={arrBeltMedalType.find((item) => item.isSelected)}
                    insufficientStakesError={insufficientStakesError}
                    selectedBelt={() => {
                        setBeltPurchaseSuccessModal(true);
                        setInsufficientStakesError(null);
                    }}
                    jumpToPurchaseToken={(isNavigate: boolean) => {
                        if (isNavigate) {
                            navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                                eventID: eventDetails?.eventID || challengeID,
                                type: "notification",
                            });
                            setShowModal(false);
                        }
                    }}
                />
            )}

            {/* Belt Purchase Success Modal */}
            {beltPurchaseSuccessModal && (
                <BeltPurchaseSuccessModal
                    arrBeltMedalType={arrBeltMedalType}
                    showModal={beltPurchaseSuccessModal}
                    setShowModal={setBeltPurchaseSuccessModal}
                    numberOfBelts={numberOfBelts}
                    dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
                />
            )}
        </Modal>
    );
}

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        justifyContent: "flex-end",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    container: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderWidth: 1,
        borderBottomWidth: 0,
        borderColor: "#DC2626",
        paddingHorizontal: 12,
        paddingTop: 8,
        paddingBottom: 20,
        height: "80%",
    },
    handleBar: {
        width: 40,
        height: 4,
        backgroundColor: "#4B5563",
        borderRadius: 2,
        alignSelf: "center",
        marginBottom: 12,
    },
    header: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
        marginBottom: 12,
    },
    scrollView: { flex: 1 },
    scrollContent: { gap: 12, paddingBottom: 12 },
    loadingContainer: { flex: 1, justifyContent: "center", alignItems: "center" },
    loadingText: { color: "#9CA3AF", marginTop: 12, fontSize: 14 },

    // Player Card
    playerCard: {
        flexDirection: "row",
        padding: 6,
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: 8,
        borderWidth: 0.8,
        borderColor: "#374151",
    },
    avatarContainer: { width: 90, alignItems: "center" },
    kallerLabel: { color: "#DC2626", fontSize: 10, fontWeight: "600", marginBottom: 2 },
    avatarWrapper: { backgroundColor: "#604e74", borderRadius: 50, overflow: "hidden" },
    statsContainer: { marginTop: 4 },
    statRow: { flexDirection: "row", justifyContent: "space-between", gap: 4 },
    statLabel: { color: "#9CA3AF", fontSize: 8 },
    statValue: { color: "#FFF", fontSize: 8, fontWeight: "600" },
    progressBar: { height: 3, borderRadius: 2, backgroundColor: "#374151" },

    // Challenge Text
    challengeTextContainer: { flex: 1, alignItems: "center", paddingHorizontal: 10 },
    challengeText: { color: "#FFF", fontSize: 14, fontWeight: "500", textAlign: "center", lineHeight: 20 },
    willStartText: { color: "#9CA3AF", fontSize: 12, marginTop: 8 },
    timeBox: { backgroundColor: "rgba(220, 38, 38, 0.2)", borderRadius: 4, paddingHorizontal: 12, paddingVertical: 6, marginTop: 4 },
    timeText: { color: "#FFC107", fontSize: 12, fontWeight: "600" },
    gameImage: { width: 80, height: 100, borderRadius: 8 },

    // Belts
    beltsCard: { padding: 12, borderRadius: 8, borderWidth: 0.8, borderColor: "#374151" },
    beltsTitle: { color: "#FFF", fontSize: 16, fontWeight: "700", textAlign: "center", marginBottom: 8 },
    beltsDescription: { color: "#9CA3AF", fontSize: 12, textAlign: "center", marginBottom: 12 },
    beltsRow: { flexDirection: "row", justifyContent: "center", gap: 16, marginBottom: 12 },
    beltItem: { alignItems: "center" },
    beltImage: { width: 60, height: 48 },
    beltAmountBox: { backgroundColor: "#374151", borderRadius: 4, paddingHorizontal: 12, paddingVertical: 2, marginTop: 4 },
    beltAmount: { color: "#FFF", fontSize: 12, fontWeight: "600" },
    creditsRow: { flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
    creditsLabel: { color: "#FFF", fontSize: 12 },
    creditsWorthLabel: { color: "#9CA3AF", fontSize: 11 },
    priceBox: { backgroundColor: "#374151", borderRadius: 6, paddingHorizontal: 16, paddingVertical: 8 },
    priceText: { color: "#FFF", fontSize: 16, fontWeight: "700" },

    // Action Buttons
    actionButtonsRow: { flexDirection: "row", justifyContent: "space-between", gap: 12 },
    negotiateButton: { flexDirection: "row", alignItems: "center", gap: 6, paddingVertical: 8, paddingHorizontal: 10, borderRadius: 4, borderWidth: 1, borderColor: "#FFF" },
    negotiateButtonText: { color: "#FFF", fontSize: 11, fontWeight: "500" },
    viewDetailsButton: { paddingVertical: 10, paddingHorizontal: 14, borderRadius: 6, borderWidth: 1, borderColor: "#DC2626" },
    viewDetailsText: { color: "#DC2626", fontSize: 12, fontWeight: "600" },

    // Rules
    rulesCard: { padding: 12, borderRadius: 8, borderWidth: 0.8, borderColor: "#374151" },
    rulesTitle: { color: "#FFF", fontSize: 14, fontWeight: "700", marginBottom: 8 },
    rulesText: { color: "#9CA3AF", fontSize: 12, lineHeight: 18 },

    // Event Details
    eventDetailsCard: { borderRadius: 8, borderWidth: 0.8, borderColor: "#374151", padding: 10 },
    eventDetailsRow: { flexDirection: "row", flexWrap: "wrap", gap: 8 },
    eventDetailItem: { minWidth: "30%", alignItems: "flex-start" },
    eventDetailLabel: { color: "#9CA3AF", fontSize: 10, marginBottom: 4 },
    eventDetailValueBox: { borderRadius: 8, borderWidth: 0.8, borderColor: "#374151", paddingHorizontal: 10, paddingVertical: 4 },
    eventDetailValue: { color: "#FFF", fontSize: 11, fontWeight: "600" },

    // Footer
    footer: { flexDirection: "row", gap: 12, marginTop: 12 },
    rejectButton: { flex: 0.8, paddingVertical: 12, borderRadius: 8, borderWidth: 1, borderColor: "#DC2626", alignItems: "center", justifyContent: "center" },
    rejectButtonText: { color: "#DC2626", fontSize: 14, fontWeight: "600" },
    acceptButton: { flex: 1.2, paddingVertical: 12, borderRadius: 8, backgroundColor: AppColors.appGreenColor_51AF07, alignItems: "center", justifyContent: "center" },
    acceptButtonText: { color: "#FFF", fontSize: 14, fontWeight: "600" },
});

export default MobileNotificationDetails;
